import { service } from '@ember/service';
import type { Snapshot } from '@ember-data/legacy-compat/-private';
import ApplicationAdapter from 'lumen/adapters/application';
import type { HotelAndMarketServiceWithHotel } from 'lumen/services/hotel-and-market';
import { APIGATEWAY } from 'lumen/utils/constants/general-constants';

export default class EventAdapter extends ApplicationAdapter {
  @service('hotel-and-market')
  declare hotelAndMarketService: HotelAndMarketServiceWithHotel;

  // Reads keep using the inherited URL building via `namespace`/`typeKey`.
  // Writes go to the API Gateway, which needs the hotel as query param.
  override buildURL(
    modelName: string,
    id: string | null,
    snapshot: Snapshot<unknown>,
    requestType?: string,
  ): string {
    // @ts-expect-error: ApplicationAdapter type declares 3 params but runtime accepts requestType as 4th
    const url = super.buildURL(modelName, id, snapshot, requestType);
    if (
      requestType &&
      ['createRecord', 'updateRecord', 'deleteRecord'].includes(requestType)
    ) {
      return `${url}?subscription_id=${this.hotelAndMarketService.hotel.id}`;
    }
    return url;
  }

  urlForCreateRecord(): string {
    return `${this.host}/${APIGATEWAY}/events`;
  }

  urlForDeleteRecord(id: string): string {
    return `${this.host}/${APIGATEWAY}/events/${id}`;
  }

  urlForUpdateRecord(id: string): string {
    return `${this.host}/${APIGATEWAY}/events/${id}`;
  }
}
